import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://www.scalexa-group.com";
const DEFAULT_DESC =
    "Consultoría de estrategia comercial, dirección externa e inteligencia artificial para pymes industriales y tecnológicas. Capta clientes y crece con método.";

function setMeta(kind, key, value) {
    const selector = `meta[${kind}="${key}"]`;
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(kind, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", value);
}

/**
 * Per-route SEO: sets document title, meta description, canonical and
 * the main Open Graph / Twitter tags. Optionally injects a page-scoped
 * JSON-LD structured-data block (removed on route change).
 */
export default function Seo({ title, description, path, jsonLd }) {
    const location = useLocation();
    useEffect(() => {
        const desc = description || DEFAULT_DESC;
        const url = `${SITE}${path || location.pathname}`;
        document.title = title;
        setMeta("name", "description", desc);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", desc);
        setMeta("property", "og:url", url);
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", desc);
        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", url);

        let script;
        if (jsonLd) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.dataset.routeSeo = "true";
            script.text = JSON.stringify(jsonLd);
            document.head.appendChild(script);
        }
        return () => {
            if (script) script.remove();
        };
    }, [title, description, path, jsonLd, location.pathname]);
    return null;
}
